<template>
    <div/>
</template>

<script>

    export default {
        data () {
            return {
            }
        },
        computed: {
            globalNavsData () {
                const { globalNavsData } = this.$store.state
                return globalNavsData
            }
        },
        watch: {
            globalNavsData (newVal) {
                this.rewriteRoute(newVal)
            }
        },
        activated () {
        },
        mounted () {
        },
        methods: {
            rewriteRoute (newVal) {
                if (newVal.length > 0) {
                    this.$router.replace({
                        name: newVal[0]
                    })
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { globalNavsData } = vm.$store.state
                vm.rewriteRoute(globalNavsData)
            })
        }
    }
</script>

<style lang="scss" scoped>
</style>
